export default {
  state:{
    mj: {
      grzhzt: [],
      xingbie: [],
      zhiye: [],
      zhiwu: [],
      zhichen: [],
      hyzk: [],
      zjlx: [],
      dkyt: [],
      xueli: [],
      fcyy:[]
    }
  },
  mutations:{
    mjAdd(state,obj){
      state.mj[obj.name] = obj.value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/meiju.js